import React, { useState, useEffect, useRef } from 'react';
import useResponsiveCanvasSize from '../hooks/useResponsiveCanvasSize';
import '../style/Canvas.css';
import { getRandomColor } from '../utils/colorUtils';
import {
    getRadiusForLayer,
    generateGradientDef,
    generateShapes
} from '../utils/svgUtils';

const Canvas = ({ layerSettings }) => {
    const fixedCanvasSize = useResponsiveCanvasSize();
    const [renderKey, setRenderKey] = useState(0);
    const bgStyle = 'dark';
    const zoom =100;
    return (
        <div className={bgStyle}>
            <svg
                key={renderKey}
                width={fixedCanvasSize}
                height={fixedCanvasSize}
                //viewBox={viewBox}
                viewBox={`0 0 ${fixedCanvasSize} ${fixedCanvasSize}`}
                xmlns="http://www.w3.org/2000/svg"
                onContextMenu={(e) => e.preventDefault()}
                style={{ pointerEvents: 'none' }}
                shapeRendering="geometricPrecision"
            >
                <defs>
                    {layerSettings.map((layer, index) =>
                        layer.colorData?.type !== 'solid'
                            ? generateGradientDef(index, layer.colorData, getRadiusForLayer(layer, fixedCanvasSize, zoom), fixedCanvasSize)
                            : null
                    )}
                </defs>

                {[...layerSettings].reverse().map((layer, indexReversed) => {
                    const actualIndex = layerSettings.length - 1 - indexReversed;
                    if (layer.showItem === false) return null;
                    return (
                        <g
                            vectorEffect="non-scaling-stroke"
                            className={`spin-${actualIndex}`}
                            key={actualIndex}
                            style={{ mixBlendMode: layer.blendMode }}
                            stroke={
                                layer.colorData?.type === 'solid'
                                    ? layer.colorData.color || layer.colorData.color1 || getRandomColor()
                                    : `url(#gradient-${actualIndex})`
                            }
                            opacity={layer.opacity / 100}
                            strokeWidth={layer.numShapes > 1000 ? 0.1 : 1}
                        >
                            {generateShapes(layer, zoom, fixedCanvasSize, false, true)}
                        </g>
                    );
                })}
            </svg>
        </div>
    );
};

export default Canvas;
